import React, { useState, useEffect } from "react";
// import "../../../assets/css/auth/password-reset.scss";
import { resetPassword } from "../../../api";
import { useNavigate, useLocation } from "react-router-dom";

function PasswordReset() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get userId from navigation state or URL params, with fallback
  const getUserIdFromState = () => {
    return location.state?.userId || 
           new URLSearchParams(location.search).get('userId') || 
           '';
  };

  const [userId, setUserId] = useState(getUserIdFromState());
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Validation helper
  const isPasswordValid = (pw) => pw.length >= 6 && pw.length <= 10;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    if (!userId || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      setLoading(false);
      return;
    }
    if (!isPasswordValid(newPassword)) {
      setError("Password must be 6-10 characters.");
      setLoading(false);
      return;
    }
    if (!isPasswordValid(confirmPassword)) {
      setError("Confirm password must be 6-10 characters.");
      setLoading(false);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }
    try {
      await resetPassword(userId, newPassword, confirmPassword);
      setSuccess("Password has been changed successfully. Please log in again.");
    } catch (err) {
      // Handle 404 status code specifically
      if (err.response?.status === 404) {
        alert("존재하지 않습니다");
        setError(""); // Remove any existing error message
      } else {
        setError(err.response?.data?.message || "Failed to reset password.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-reset-mobile">
    
      <main className="reset-main-column">
        <h2 className="reset-title">
          <span className="bar"></span>비밀번호 재설정
        </h2>
        <div className="divider"></div>
        {/* <button className="next-btn" onClick={() => navigate('/login')}>뒤로가기</button> */}
        <div className="reset-message">
          임시 비밀번호로 로그인 하셨습니다.<br />
          보안을 위하여 비밀번호를 새로 설정해 주세요.
        </div>
        <form className="reset-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>아이디</label>
            <input type="text" value={userId} onChange={e => setUserId(e.target.value)} disabled/>
          </div>
          <div className="form-group">
            <label>신규 비밀번호</label>
            <div className="password-input-container">
            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
            <p className="password-length-info">6~10자 영문, 숫자, 특수기호 사용 가능</p>
            </div>
          </div>
          <div className="form-group">
            <label>비밀번호 확인</label>
            <div className="confirm-password-input-container">
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
            {newPassword && confirmPassword && (
              <div className={`info-msg ${newPassword === confirmPassword ? "success" : "error"}`}>
                {newPassword === confirmPassword ? "*패스워드 일치" : "*패스워드 불일치"}
              </div>
            )}
            </div>
          </div>
          {error && <div className="error-msg">{error}</div>}
          {success && <div className="success-msg">{success}</div>}
          <button type="submit" className="reset-btn" disabled={loading}>
            {loading ? "확인 중..." : "확인"}
          </button>
        </form>
      </main>
      
    </div>
  );
}

export default PasswordReset; 